module.exports = __webpack_public_path__ + "static/media/view3.1dde3cb4.jpg";